var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStats(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3335 17.5H9.3335V12.5H7.3335V17.5ZM15.3335 17.5H17.3335V7.5H15.3335V17.5ZM11.3335 17.5H13.3335V10H11.3335V17.5ZM5.3335 21.5C4.7835 21.5 4.31266 21.3042 3.921 20.9125C3.52933 20.5208 3.3335 20.05 3.3335 19.5V5.5C3.3335 4.95 3.52933 4.47917 3.921 4.0875C4.31266 3.69583 4.7835 3.5 5.3335 3.5H19.3335C19.8835 3.5 20.3543 3.69583 20.746 4.0875C21.1377 4.47917 21.3335 4.95 21.3335 5.5V19.5C21.3335 20.05 21.1377 20.5208 20.746 20.9125C20.3543 21.3042 19.8835 21.5 19.3335 21.5H5.3335Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats);
export default __webpack_public_path__ + "static/media/stats.570b7d3c8e1f3222dbcc76c5da1e9921.svg";
export { ForwardRef as ReactComponent };